export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
  region: string;
  domain: string;
  redirectSignIn: string;
  redirectSignOut: string;
}

const COGNITO_CONFIG_FIELDS: { key: keyof CognitoConfig; label: string }[] = [
  { key: 'userPoolId', label: 'COGNITO_USER_POOL_ID' },
  { key: 'clientId', label: 'COGNITO_CLIENT_ID' },
  { key: 'domain', label: 'cognito domain (set in build-config.ts)' },
  { key: 'region', label: 'region (hardcoded us-east-1)' },
  { key: 'redirectSignIn', label: 'redirectSignIn (derived from config.host)' },
  { key: 'redirectSignOut', label: 'redirectSignOut (derived from config.host)' },
];

export function getMissingCognitoConfig(config?: Partial<CognitoConfig>): string[] {
  return COGNITO_CONFIG_FIELDS
    .filter(({ key }) => !config?.[key])
    .map(({ label }) => label);
}
